import moment from 'moment'

export function formatDate(date, format = 'DD/MM/YYYY') {
    if (!date) {
        return ''
    }
    const parsed = moment(date)
    return parsed.isValid() ? parsed.format(format) : ''
}

// The backend date fields are Symfony DateType widgets that only accept YYYY-MM-DD
export function toInputDate(date) {
    return formatDate(date, 'YYYY-MM-DD') || null
}

export function formatCurrency(value) {
    const numericValue = Number(value)
    const safeValue = Number.isNaN(numericValue) ? 0 : numericValue
    return safeValue.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
}

export function entityId(entity) {
    if (entity === null || entity === undefined || entity === '') {
        return null
    }
    if (typeof entity === 'object') {
        return entity.id || null
    }
    return entity
}

export function pick(source, keys) {
    const result = {}
    keys.forEach(key => {
        result[key] = source[key] === undefined ? null : source[key]
    })
    return result
}

export function fullName(person) {
    if (!person) {
        return ''
    }
    return [person.firstName, person.lastName].filter(Boolean).join(' ')
}

export function activeCardNumbers(cards, type = null) {
    return (cards || [])
        .filter(card => card.active && (!type || card.type === type))
        .map(card => card.number)
}

export function memberLabel(member) {
    if (!member) {
        return ''
    }
    const cards = activeCardNumbers(member.cards)
    const number = member.number ? ` #${member.number}` : ''
    return fullName(member) + number + (cards.length ? ` [${cards.join(', ')}]` : '')
}

export function errorMessage(error, fallback = 'Something went wrong') {
    if (!error) {
        return fallback
    }
    if (typeof error === 'string') {
        return error
    }
    if (error.isApiError) {
        return error.message
    }
    if (error.response) {
        const data = error.response.data
        if (error.response.status === 403) {
            return (data && data['403']) || 'You do not have access to this.'
        }
        if (data && typeof data === 'object') {
            const keyed = ['400', '404', '500', 'error'].map(key => data[key]).find(value => typeof value === 'string')
            return data.message || data.detail || data.title || keyed || fallback
        }
        if (error.response.status >= 500) {
            return 'The server ran into an error. Please try again.'
        }
        return fallback
    }
    if (error.message === 'Network Error') {
        return 'Could not reach the server. Check your connection.'
    }
    return fallback
}

export function saveBlob(data, fileName, type = 'text/csv;charset=utf-8') {
    const blob = data instanceof Blob ? data : new Blob([data], { type })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

export function dateStamp() {
    return moment().format('YYYY-MM-DD_HHmm')
}
